<template>
  <div class="contents" v-if="!reactionsDisabled && id">
    <a
      v-for="(reaction, index) in reactionsStore.emojiList"
      @click.prevent="onClick(id, reaction)"
      :key="index"
      @mouseover="isHovering = index"
      @mouseout="isHovering = null"
      :class="buttonColor(reaction, index, isHovering)"
      :data-testid="`viewer-reaction-${reaction}`"
      class="reactions-button"
    >
      <span class="reactions-emoji">{{ findByName(reaction) || 0 }}</span>
      <span class="reactions-counter" :class="countColor(reaction, index, isHovering)">{{ reactionsCount(reaction) }}</span>
    </a>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, watch } from 'vue';
import { useReactionsStore } from './../store/useReactionsStore';
import { useEmoji } from '../../../composables/useEmoji';
import { useReactions } from '../composables/useReactions';

const props = defineProps<{
  id?: string; // id of the thing with reactions (item, comment, whatever)
}>();

const reactionsStore = useReactionsStore();

const isHovering = ref<number | null>(null);
const { findByName } = useEmoji();
const { countColor, buttonColor, onClick, load, reactionsDisabled, reactionsCount } = useReactions();

const loadReactions = () => props.id && load(props.id);

onMounted(loadReactions);
watch(() => props.id, loadReactions);
</script>

<style scoped>
.reactions-button {
  @apply flex items-center gap-2 px-3 py-1 border cursor-pointer select-none rounded-10 sm:h-[3rem] border-slate-300 dark:border-zinc-600 focus:ring focus:ring-blue-500/50 focus:outline-none;
}
.reactions-emoji {
  @apply sm:text-3xl;
}
.reactions-counter {
  @apply inline-block text-xs font-bold sm:text-base dark:text-white;
  min-width: 1ch;
}
</style>
